import { render } from "./index.vue?vue&type=template&id=3f1565d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3f1565d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f1565d6"

export default script